import React from 'react';

type CorporateCompanyBadgeProps = {
  name: string;
  /** Slightly smaller for dense queue cards. */
  size?: 'sm' | 'md';
};

/** Corporate partner registration — billed to this company (Customer_CorporateCompany). */
export function CorporateCompanyBadge({ name, size = 'md' }: CorporateCompanyBadgeProps) {
  const trimmed = name.trim();
  if (!trimmed) return null;

  const fontSize = size === 'sm' ? 10 : 11;
  const padding = size === 'sm' ? '2px 8px' : '3px 10px';
  const maxWidth = size === 'sm' ? 148 : 180;

  return (
    <span
      title={`Corporate registration — ${trimmed}`}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 4,
        padding,
        borderRadius: 12,
        fontSize,
        fontWeight: 700,
        lineHeight: 1.2,
        background: '#ede9fe',
        color: '#5b21b6',
        border: '1px solid #c4b5fd',
        whiteSpace: 'nowrap',
        maxWidth,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      }}
    >
      <span aria-hidden style={{ flexShrink: 0 }}>
        🏢
      </span>
      <span style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>{trimmed}</span>
    </span>
  );
}
